/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

const CONFIG_REGISTER_FLOWS = new Set([
  'signup',
  'register',
  'enrollProfile',
]);
const CONFIG_AUTH_FLOWS = new Set([
  'authenticate',
  'login',
  'signin',
]);
const CONFIG_RECOVER_FLOWS = new Set([
  'recoverPassword',
  'resetPassword',
]);
const CONFIG_UNLOCK_FLOWS = new Set([
  'unlockAccount',
]);

export const isConfigRegisterFlow = (flow: string | undefined): boolean => CONFIG_REGISTER_FLOWS.has(flow || '');
export const isConfigRecoverFlow = (flow: string | undefined): boolean => CONFIG_RECOVER_FLOWS.has(flow || '');
export const isConfigUnlockFlow = (flow: string | undefined): boolean => CONFIG_UNLOCK_FLOWS.has(flow || '');
export const isConfigAuthFlow = (flow: string | undefined): boolean => CONFIG_AUTH_FLOWS.has(flow || '');
